// Foundations
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, } from '@angular/forms';

// Models
import { Abbreviation } from '../../../models/abbreviation.model';

// JSON
import usStateList from 'src/assets/json/us-state-list.json';
import caProvinceList from 'src/assets/json/ca-province-list.json';

const POSTAL_CODE_REGEX = /^(\d{5}(\-\d{4})?|[A-Za-z]\d[A-Za-z][ \-]?\d[A-Za-z]\d)$/;

@Component({
  selector: 'app-home-address-form',
  templateUrl: './home-address-form.component.html',
  styleUrls: ['./home-address-form.component.scss']
})

export class HomeAddressFormComponent implements OnInit, OnChanges {

  @Input() homeAddressForm: FormGroup;

  countryList: Abbreviation[] = [
    { fullName: 'USA', abbreviation: 'us' },
    { fullName: 'Canada', abbreviation: 'ca' }
  ];
  stateProvinceList: Abbreviation[];

  constructor(
    private fb: FormBuilder,
  ) {
    this.homeAddressForm = this.fb.group({
      country: [this.countryList[0].abbreviation, Validators.required],
      address1: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      stateProvince: ['', Validators.required],
      postalCode: ['', Validators.required],
    }, { validator: this.checkPostalCode });
  }

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.setStateProvinceList(this.homeAddressForm.value.country);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setStateProvinceList(changes.homeAddressForm.currentValue.value.country);
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  getForm() {
    return this.homeAddressForm;
  }

  get f() {
    return this.homeAddressForm.controls;
  }

  onCountryChange(country: 'us' | 'ca') {
    this.setStateProvinceList(country);
    this.homeAddressForm.patchValue({
      stateProvince: '',
      postalCode: '',
    });
  }

  // for mat-select to compare objects as option values
  compareFn(optionOne, optionTwo): boolean {
    return optionOne === optionTwo;
  }

  // Private Methods
  // ------------------------------------------------------------------------------------

  private setStateProvinceList(country: 'us' | 'ca') {
    switch (country) {
      case 'us':
        this.stateProvinceList = usStateList;
        break;
      case 'ca':
        this.stateProvinceList = caProvinceList;
        break;
    }
  }

  private checkPostalCode(group: FormGroup) {
    const errors: { [k: string]: any } = {};
    const postalCode = group.controls.postalCode.value;

    if (!POSTAL_CODE_REGEX.test(postalCode)) {
      errors.postalCode = true;
    }

    return errors;
  }

}
